// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mwc-markets-treasury.markets-ui-container__fixed-height .mwc-markets-treasury-ui-table{height:100%}\n", "",{"version":3,"sources":["webpack://packages/treasury/src/components/table-view.vue"],"names":[],"mappings":"AAAA,wFAAwF,WAAW","sourcesContent":[".mwc-markets-treasury.markets-ui-container__fixed-height .mwc-markets-treasury-ui-table{height:100%}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
